interface IRowData {
  IsExpanded?: number | null
}

interface IExpandTableRow<T> {
  data: T[]
  keyField: string
  keyFieldValue: string | number
}

export const expandTableRow = <T extends IRowData>({
  data,
  keyFieldValue,
  keyField,
}: IExpandTableRow<T>) => {
  return data.map((el) => {
    if (el[keyField] === keyFieldValue) {
      return { ...el, IsExpanded: 1 }
    }
    return el
  })
}
